import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { getUrlParams } from '../../../functions/get-url-params';
import { CaseType } from '../../../pipes/case.pipe';
import { BaseComponent } from '../../base/base.component';
import { ButtonComponent } from '../../core/buttons/button.component';
import { LinkLabelComponent } from '../../core/labels/link-label.component';
import { PageHeaderComponent } from '../../core/labels/page-header.component';
import { ActionRowComponent } from '../../core/panels/action-row.component';
import { DialogComponent } from '../../core/panels/dialog.component';
import { ReportScheduleStepComponent } from './steps/report-schedule-step.component';

@Component({
  selector: 'app-edit-schedule',
  imports: [
    ReportScheduleStepComponent,
    ActionRowComponent,
    CommonModule,
    DialogComponent,
    ButtonComponent,
    RouterModule,
    LinkLabelComponent,
    PageHeaderComponent,
  ],
  template: ` <app-dialog #dialog label="Cancel edit" width="35rem">
      <ng-template #content>
        <div class="tw-pb-8">
          Press confirm to cancel editing this schedule.
        </div>
        <app-action-row>
          <app-button
            icon="fa-check fa-light"
            (click)="dialog.visible = false"
            right1
            routerLink="/reports"
            label="Confirm"
          />
          <app-button
            (click)="dialog.visible = false"
            emphasis="Low"
            right2
            label="Go back"
          />
        </app-action-row>
      </ng-template>
    </app-dialog>

    <app-page-header label="Edit report schedule" headerSize="h1" />

    <app-action-row>
      <app-link-label left1 (click)="dialog.visible = true"
        >Cancel schedule</app-link-label
      >
    </app-action-row>

    <div class="tw-pt-4 tw-flex tw-justify-center">
      <div class="tw-w-[1000px] ">
        <app-report-schedule-step />
        <app-action-row>
          <app-button right1 label="Save" />
          <app-button right2 emphasis="Low" label="Cancel" />
        </app-action-row>
      </div>
    </div>`,
  styles: [
    `
      :host ::ng-deep h2 {
        font-size: 20px;
        font-weight: normal;
      }
    `,
  ],
})
export class EditScheduleComponent extends BaseComponent implements OnInit {
  protected reportEdit: ReportEdit;

  protected step: string;

  async ngOnInit() {
    this.reportEdit = new ReportEdit();
    const params = getUrlParams();
    this.step = params.step;
  }
}

export class ReportEdit {
  client: string;
  report: Report;
}

export interface Report {
  type: ReportType;
  title: string;
  description: string;
  favorite: boolean;
  typeTag: string;
  labelCase: CaseType;
}

export type ReportType =
  | 'carrier'
  | 'design-your-own'
  | 'detail'
  | 'financial'
  | 'summary'
  | 'usage'
  | 'other';
